import { useDialogStore } from '../stores/dialogStore';
import { ConfirmDialogOptions, AlertDialogOptions } from '../types/dialog';

export const useDialog = () => {
  const { showConfirmDialog, showAlertDialog } = useDialogStore();

  const confirm = (options: ConfirmDialogOptions) => {
    return showConfirmDialog(options);
  };

  const alert = (options: AlertDialogOptions) => {
    return showAlertDialog(options);
  };

  return {
    confirm,
    alert,
  };
};